__turbopack_context__.v({
  "modalFooterCta": "DiagnosticLearnMoreModal-module__TcRUiq__modalFooterCta",
});
